import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import logo from './img/logo.png'
import aside from './img/aside.png'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'bonda';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "Usuário";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-bonda-container" ref={nodeRef}>
        <Form onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="bonda-form-container">
            <img src={logo} alt="logo" className="logo-bonda" />
            <h1 className="desc">{translate("ClientAuthentication")}</h1>
            <div className="ingre"><p>{translate("CredentialsLabel")}</p> </div>
            <div className="bonda-separator"></div>
            <Row className="bonda-form-body">
              <Col sm="12" xs="12" md="12" className="bonda-input">
                <div><p className="detail">{translate("PlaceholderUserName")}</p></div>
                <Input
                  className="user-input-bonda"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  onChange={e => setUsername(e.target.value)}
                  placeholder={translate("user@mail.com")}
                />
              </Col>
              <Col sm="12" xs="12" md="12" className="bonda-input">
                <div className="detail"><p>{translate("PlaceholderPassword")}</p></div>
                <Input
                  className="pass-input-bonda"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeholder={translate("***************")}
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
              <Col sm="12" xs="12" md="12" className="bonda-input">
                {!onLogin ? (
                  <button
                    block={String(!parameters.failureRedirect)}
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="enter-bonda"
                    disabled={!props.turnstileSuccess}
                  >
                    {translate("ButtonEnter")}
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </Col>
              <p className="regis"> <a href="https://somosflux.com/miflux/#/flux-mas" target="_blank" rel="noreferrer">{translate("RegisterAccount")}</a></p>
            </Row>
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
            <Row>
              <Col style={{ padding: '0' }}>
                <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              </Col>
            </Row>
          </Container>
        </Form>
        <div className="aside-bonda"><img src={aside} alt="aside"></img></div>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true });
